
import { ModelBase } from "@models/UpsertableBase";
import { UpgradableNumber } from "@dndModels/misc/UpgradableNumber";
import { DataType } from "@dndModels/Types";

/**
 * This is a generic term for Spell Slots, Ki Points, Sorcery Points,
 * Lay on Hands, Healing Light, etc.  
 * refresh_rule is when this refreshes (generally short or long).
 */
export class Resource extends ModelBase {
  data_type: DataType = "resource";
  refresh_rule = "";
  refresh_x_on_short: UpgradableNumber = new UpgradableNumber();
  default_dice_size = 1;
  singular = "";
  zero_on_rest = false;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.refresh_rule = obj.refresh_rule ? `${obj.refresh_rule}` : "";
      this.refresh_x_on_short = obj.refresh_x_on_short ? new UpgradableNumber(obj.refresh_x_on_short) : new UpgradableNumber();
      this.default_dice_size = obj.default_dice_size ? +obj.default_dice_size : 1;
      this.singular = obj.singular ? obj.singular : "";
      if (this.singular === "") {
        if (this.name.endsWith("Dice")) {
          this.singular = this.name.substring(0, this.name.length - 2) + "e";
        } else if (this.name.endsWith("s")) {
          this.singular = this.name.substring(0, this.name.length - 1);
        } else {
          this.singular = this.name;
        }
      }
      this.zero_on_rest = obj.zero_on_rest ? obj.zero_on_rest : false;
    }
    this.loaded = true;
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      refresh_rule: this.refresh_rule,
      refresh_x_on_short: this.refresh_x_on_short.toDBObj(),
      default_dice_size: this.default_dice_size,
      singular: this.singular,
      zero_on_rest: this.zero_on_rest
    };
  }

  toLight(): any {
    return this.toDBObj();
  }

  copy(copyMe: Resource, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.refresh_rule = copyMe.refresh_rule;
    this.refresh_x_on_short = copyMe.refresh_x_on_short;
    this.default_dice_size = copyMe.default_dice_size;
    this.singular = copyMe.singular;
    this.zero_on_rest = copyMe.zero_on_rest;
  }

  clone(drop_ids = false): Resource {
    const new_obj = new Resource();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}